import { createAction } from '@reduxjs/toolkit';
import { createActionWithCallback } from 'core/store/utils';
import { RequestError, Typology, TypologyForm } from 'types';

export const createTypology = createActionWithCallback<void, Error>()(
  'typology/create-typology',
  (typology: TypologyForm) => ({
    payload: typology,
  })
);

export const createdTypology = createAction('typology/created-typology', (data?: Typology, error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export const updateTypology = createActionWithCallback<void, Error>()(
  'typology/update-typology',
  (typology: TypologyForm) => ({
    payload: typology,
  })
);

export const updatedTypology = createAction('typology/updated-typology', (data?: Typology, error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export const deleteTypology = createAction('typology/delete-typology', (id: string) => ({
  payload: undefined,
  meta: { id },
}));

export const deletedTypology = createAction('typology/deleted-typology', (data?: boolean, error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export default {
  createTypology,
  createdTypology,
  updateTypology,
  updatedTypology,
  deleteTypology,
  deletedTypology,
};
